const getHeaders = () => {
    return {
        authorization: `Bearer ${localStorage.getItem('MemberAuth')}`,
        membercode: `${localStorage.getItem('MemberCode')}`,
        memberid: `${localStorage.getItem('MemberId')}`,
    }
}

export default getHeaders
